import angular from 'angular';
import { AngularServices } from '../../../../modules/core';
import { RootScopeEvents } from '../../../../common/services/root-scope-types';
export class ClosedCaptionsService {
    /* @ngInject */
    constructor(VideoProviderFactory, pn, $rootScope) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.pn = pn;
        this.$rootScope = $rootScope;
        this.participantsWithCaptionsEnabledMap = new Map();
    }
    /**
     * Called by provider to toggle on/off captions locally.
     */
    toggleCaptions(enabled) {
        const doctorUuid = this.pn.getUuid();
        if (enabled) {
            // Add doctor to participants map
            this.participantsWithCaptionsEnabledMap.set(doctorUuid, true);
            // If this is the first participant to enable captions, start captions for the session
            if (this.participantsWithCaptionsEnabledMap.size === 1) {
                void this.startCaptions();
            }
        }
        else {
            this.handleParticipantCaptionsOff(doctorUuid);
        }
        this.$rootScope.$emit(RootScopeEvents.CLOSED_CAPTIONS.DOCTOR_TOGGLED, enabled);
    }
    /**
     * Patient enabled/disabled captions via realtime signaling.
     */
    onCaptionsToggle(message, person) {
        const identityId = person.uuid;
        const status = message.content.status; // 'on' or 'off'
        if (status === 'on') {
            this.participantsWithCaptionsEnabledMap.set(identityId, true);
            // If this is the first participant to enable captions, start captions for the session
            if (this.participantsWithCaptionsEnabledMap.size === 1) {
                void this.startCaptions();
            }
        }
        if (status === 'off') {
            this.handleParticipantCaptionsOff(identityId);
        }
    }
    resetCaptions() {
        if (this.participantsWithCaptionsEnabledMap.size > 0) {
            this.participantsWithCaptionsEnabledMap.clear();
            this.stopCaptions();
        }
    }
    handleParticipantCaptionsOff(identityId) {
        this.participantsWithCaptionsEnabledMap.delete(identityId);
        // If no one has captions enabled, stop captions for the session
        if (this.participantsWithCaptionsEnabledMap.size === 0) {
            this.stopCaptions();
        }
    }
    async startCaptions() {
        try {
            if (Boolean(this.VideoProviderFactory.activeProvider)) {
                await this.VideoProviderFactory.activeProvider.startLiveCaptions();
            }
        }
        catch (error) {
            /**
             * In V2 we do not have at all API request errors so currently  we can keep it unhandled.
             * @todo: If there will be some issues we can schedule some retry mechanism here. But it would be anyway pretty tricky.
             * In most cases it might fails because connection might be lost. Then we would not even be able to signal it to other participants.
             * So now if it fails we just clear the map and people can close and open captions again so it will be triggered one more time.
             */
            this.participantsWithCaptionsEnabledMap.clear();
            this.$rootScope.$emit(RootScopeEvents.CLOSED_CAPTIONS.FAIL_START_VIA_REALTIME_SIGNALING, error);
        }
    }
    stopCaptions() {
        if (Boolean(this.VideoProviderFactory.activeProvider)) {
            this.VideoProviderFactory.activeProvider.stopLiveCaptions();
        }
    }
}
export default angular
    .module('doxy.providers.video.common.services.closedCaptionsService', [])
    .service(AngularServices.ClosedCaptionsService, ClosedCaptionsService).name;
